var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 17,
    viewBox: "0 0 5 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4449 15.0636H2.34121M2.42254 15.4838C2.18923 15.4838 2 15.2944 2 15.061C2 14.8277 2.18923 14.6387 2.42254 14.6387C2.65584 14.6387 2.84508 14.8277 2.84508 15.061C2.84508 15.2944 2.65584 15.4838 2.42254 15.4838Z",
    stroke: "black",
    strokeWidth: 2.43025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4449 8.74089H2.34121M2.42254 9.16083C2.18923 9.16083 2 8.9716 2 8.73829C2 8.50499 2.18923 8.31592 2.42254 8.31592C2.65584 8.31592 2.84508 8.50499 2.84508 8.73829C2.84508 8.9716 2.65584 9.16083 2.42254 9.16083Z",
    stroke: "black",
    strokeWidth: 2.43025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4449 2.42497H2.34121M2.42254 2.84501C2.18923 2.84501 2 2.65571 2 2.42238C2 2.18906 2.18923 2 2.42254 2C2.65584 2 2.84508 2.18906 2.84508 2.42238C2.84508 2.65571 2.65584 2.84501 2.42254 2.84501Z",
    stroke: "black",
    strokeWidth: 2.43025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.f83a8393bfa945bf041271716c5158f5.svg";
export { ForwardRef as ReactComponent };